module.exports = __webpack_public_path__ + "static/img/t3.f205d9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/technology/t3.jpg
// module id = TTjH
// module chunks = 0